<div class="profile-container">
    <div class="">
        <div class="profile-content">    
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <select name="" id="" (change)="getAllCompatibleDepreciationHistorys(isCompatible)" [(ngModel)]="isCompatible">
                          <option [ngValue]="true">{{ 'depreciation-history.depreciationCompatibleAssets' | translate }}</option>
                          <option [ngValue]="false">{{ 'depreciation-history.depreciationIncompatbleAssets' | translate }}</option>
                        </select>
                        <div class="search">
                            <form autocomplete="off" >
                                <input type="text" (keyup.enter)="getAllAssetDepreciationMethodByWildSearch()" [ngModelOptions]="{standalone: true}" placeholder="search" [(ngModel)]="searchFilter">
                            </form>
                            <i class="bi bi-search" (click)="getAllAssetDepreciationMethodByWildSearch()"></i>
                        </div>
                        <!-- <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button> -->
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                  
                </div>

                <div class="header-block">
                 <div class="total-assets">
                  <p>{{ 'depreciation-history.totalAssets' | translate }} :<span>{{totalDepreciationCount}}</span></p>
                  <p>{{ 'depreciation-history.totalDepreciationCompatibleAssets' | translate }} :<span>{{compatibleDepreciationCount}}</span></p>
                  <p>{{ 'depreciation-history.totalDepreciationIncompatibleAssets' | translate }} :<span>{{notCompatibleDepreciationCount}}</span></p>
                 </div>
                </div>

                <div *ngIf="isCompatible">
                  <table class="table table-striped">
                      <thead>
                          <tr>
                              <th style="width: 8%;">{{ 'depreciation-history.id' | translate }}</th>
                              <th style="width: 12%;">{{ 'depreciation-history.assetName' | translate }}</th>
                              <th style="width: 15%;">{{ 'depreciation-history.assetCategory' | translate }}</th>
                              <th style="width: 15%;">{{ 'depreciation-history.depreciationMethod' | translate }}</th>
                              <th style="width: 10%;">{{ 'depreciation-history.originalCost' | translate }}</th>
                              <th style="width: 15%;">{{ 'depreciation-history.putToUseDate' | translate }}</th>
                              <th style="width: 15%;">{{ 'depreciation-history.depreciatedCost' | translate }}</th>
                              <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                          </tr>
                      </thead>
                  </table>
                  <div *ngIf="!isLoading">
                      <div class="data-view" *ngFor="let list of depreciationHistoryList | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: pageNumber,
                          totalItems: totalRecords
                          }  ;let i = index">
                          <p style="width: 8%;">{{list.depreciationHistoryId || '--'}}</p>
                          <p style="width: 12%;">{{list.assetName || '--'}}</p>
                          <p style="width: 15%;">{{list.assetCategory || '--'}}</p>
                          <p style="width: 15%;">{{list.depreciationMethod || '--'}}</p>
                          <p style="width: 10%;">{{list.originalCost || '--'}}</p>
                          <p style="width: 15%;">{{list.putToUseDate || '--'}}</p>
                          <p style="width: 15%;">{{list.depreciatedCost || '--'}}</p>
                          <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                              <i data-toggle="modal" title="View" (click)="getDepreciationHistoryById(list.depreciationHistoryId)" data-target="#viewModal" class="bi bi-eye-fill"></i>

                              <!-- <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square" (click)="getDepreciationRegisterById(list.depreciationRegisterId)" data-toggle="modal" data-target="#editModal" ></i> -->
                              <!-- <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3" (click)="deleteIdSelect(list.id,list)" data-toggle="modal" data-target="#deleteModal"></i> -->
                          </p>
                      </div>
                  </div>
                </div>

                 <div *ngIf="!isCompatible">
                  <table class="table table-striped">
                      <thead>
                          <tr>
                              <th style="width: 25%;">{{ 'depreciation-history.id' | translate }}</th>
                              <th style="width: 25%;">{{ 'depreciation-history.serialNo' | translate }}</th>
                              <th style="width: 25%;">{{ 'depreciation-history.assetName' | translate }}</th>
                              <th style="width: 25%;" class="">{{ 'depreciation-history.originalCost' | translate }}</th>
                          </tr>
                      </thead>
                  </table>
                  <div *ngIf="!isLoading">
                      <div class="data-view" *ngFor="let list of depreciationHistoryList | paginate : {
                          itemsPerPage: tableSize,
                          currentPage: pageNumber,
                          totalItems: totalRecords
                          }  ;let i = index">
                          <p style="width: 25%;">{{list.depreciationHistoryId || '--'}}</p>
                          <p style="width: 25%;">{{list.serialNo || '--'}}</p>
                          <p style="width: 25%;">{{list.assetName || '--'}}</p>
                          <p style="width: 25%;">{{list.originalCost || '--'}}</p>
                        
                      </div>
                  </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader"  *ngIf="!isLoading && depreciationHistoryList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                    [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Confirmation
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete the record  <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalDelete" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="deleteDepreciationRegister()" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Add Depreciation Register
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="row" [formGroup]="addForm">
          <!-- Asset Name -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Asset <span class="required">*</span></label>
              <select class="form-control" formControlName="assetName">
                <option value="" selected disabled>-- Asset --</option>
                <option *ngFor="let list of objectInfoList" [value]="list.givenName">
                  {{ list.givenName }}
                </option>
              </select>
            </div>
          </div>



          <!-- Year -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Year <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="year" min="{{minYear}}" max="{{maxYear}}" placeholder="YYYY">
            </div>
          </div>

          <!-- Depreciation Amount -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Depreciation Amount <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="depAmount">
            </div>
          </div>

          <!-- Accumulated Depreciation Value -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Accumulated Depreciation Value <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="accumulatedDepValue">
            </div>
          </div>

          <!-- Purchased Value -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Purchased Value <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="purchasedAmt">
            </div>
          </div>

          <!-- Current Value -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Current Value <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="currentAmt">
            </div>
          </div>

          <!-- Asset Category -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Asset Category <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="assetCategory">
            </div>
          </div>

          <!-- Depreciation Method -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Depreciation Method <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="depreciationMethod">
            </div>
          </div>

          <!-- Put To Use Date -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Put To Use Date <span class="required">*</span></label>
              <input type="date" class="form-control" formControlName="putToUseDate">
            </div>
          </div>

          <!-- Last Run Date -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Last Run Date <span class="required">*</span></label>
              <input type="date" class="form-control" formControlName="lastRunDate">
            </div>
          </div>

          <!-- Depreciated Cost -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Depreciated Cost <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="depreciatedCost">
            </div>
          </div>

          <!-- Original Cost -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Original Cost <span class="required">*</span></label>
              <input type="number" class="form-control" formControlName="originalCost">
            </div>
          </div>

          <!-- Reason -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Reason <span class="required">*</span></label>
              <input type="text" class="form-control" formControlName="reason">
            </div>
          </div>

          <!-- Depreciation Compatible -->
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <label>Depreciation Compatible <span class="required">*</span></label>
              <select class="form-control" formControlName="depreciationCompatible">
                <option value="" selected disabled>-- Select --</option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>

            <!-- Description -->
          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <label>Description</label>
              <textarea name="" id="" class="form-control" formControlName="description"></textarea>
            </div>
          </div>

        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" id="closeModalAdd" class="btn btn-secondary" data-dismiss="modal">
            Cancel
          </button>
          <button type="button" (click)="addDepreciationRegister()" class="btn btn-primary">
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Depreciation Register
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="row" [formGroup]="updateForm">
                 <!-- Asset Name -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                    <label>Asset <span class="required">*</span></label>
                    <select class="form-control" formControlName="assetName">
                        <option value="" selected disabled>-- Asset --</option>
                        <option *ngFor="let list of objectInfoList" [value]="list.givenName">
                        {{ list.givenName }}
                        </option>
                    </select>
                    </div>
                </div>



                <!-- Year -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                    <label>Year <span class="required">*</span></label>
                    <input type="number" class="form-control" formControlName="year" min="{{minYear}}" max="{{maxYear}}" placeholder="YYYY">
                    </div>
                </div>

                <!-- Depreciation Amount -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Depreciation Amount <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="depAmount">
                    </div>
                </div>

                <!-- Accumulated Depreciation Value -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Accumulated Depreciation Value <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="accumulatedDepValue">
                    </div>
                </div>

                <!-- Purchased Value -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Purchased Value <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="purchasedAmt">
                    </div>
                </div>

                <!-- Current Value -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Current Value <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="currentAmt">
                    </div>
                </div>

                <!-- Asset Category -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Asset Category <span class="required">*</span></label>
                        <input type="text" class="form-control" formControlName="assetCategory">
                    </div>
                </div>

                <!-- Depreciation Method -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Depreciation Method <span class="required">*</span></label>
                        <input type="text" class="form-control" formControlName="depreciationMethod">
                    </div>
                </div>

                <!-- Put To Use Date -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Put To Use Date <span class="required">*</span></label>
                        <input type="date" class="form-control" formControlName="putToUseDate">
                    </div>
                </div>

                <!-- Last Run Date -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Last Run Date <span class="required">*</span></label>
                        <input type="date" class="form-control" formControlName="lastRunDate">
                    </div>
                </div>

                <!-- Depreciated Cost -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Depreciated Cost <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="depreciatedCost">
                    </div>
                </div>

                <!-- Original Cost -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Original Cost <span class="required">*</span></label>
                        <input type="number" class="form-control" formControlName="originalCost">
                    </div>
                </div>

                <!-- Reason -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Reason <span class="required">*</span></label>
                        <input type="text" class="form-control" formControlName="reason">
                    </div>
                </div>

                <!-- Depreciation Compatible -->
                <div class="col-lg-6 col-md-6">
                    <div class="form-group">
                        <label>Depreciation Compatible <span class="required">*</span></label>
                        <select class="form-control" formControlName="depreciationCompatible">
                            <option value="" selected disabled>-- Select --</option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                        </select>
                    </div>
                </div>

                    <!-- Description -->
                <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea name="" id="" class="form-control" formControlName="description"></textarea>
                    </div>
                </div>
                
                </div>
                <div class="modal-footer">
                    <button id="closeModalUpdate" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="updateDepreciationRegister()" class="btn btn-primary">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>




<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'depreciation-history.headings.detail' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleDepreciationdeHistoryData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.assetName' | translate }} :</label>
                <p>{{ viewData.assetName || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.serialNo' | translate }} :</label>
                <p>{{ viewData.serialNo || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.assetCategory' | translate }}:</label>
                <p>{{ viewData.assetCategory || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.depreciationMethod' | translate }}:</label>
                <p>{{ viewData.depreciationMethod || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.originalCost' | translate }}:</label>
                <p>{{ viewData.originalCost || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.procurementDate' | translate }}:</label>
                <p>{{ viewData.procurementDate || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.putToUseDate' | translate }}:</label>
                <p>{{ viewData.putToUseDate || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.depreciatedCost' | translate }}:</label>
                <p>{{ viewData.depreciatedCost || '--' }}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'depreciation-history.depreciationCompatible' | translate }}:</label>
                <p>{{ viewData.compatible ? 'Yes' : 'No' }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
